import React, { useEffect, useState } from 'react';
import Axios, { CancelTokenSource } from 'axios';
import useCollapse from 'react-collapsed';

import Table from '../../../components/Table';
import { useMonitoring } from '../useMonitoring';
import { IScannersMonitoring } from '../../../types/types';
import { getObjectToStringMatrix } from '../../../utils/Convert';
import ChevronDown from '../../../icons/ChevronDown';
import ChevronRight from '../../../icons/ChevronRight';
import { scannersHeaders } from '../HeadersData';
import * as S from '../styles';

export function ScannerTable() {
  const [scanners, setScanners] = useState<IScannersMonitoring[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEmpty, setIsEmpty] = useState<boolean>(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const { getCollapseProps, getToggleProps } = useCollapse({ defaultExpanded: true });
  const { getScannersData, renderData } = useMonitoring();

  useEffect(() => {
    let mounted = true;
    let interval: NodeJS.Timer;
    const currentRequest: CancelTokenSource = Axios.CancelToken.source();

    if (mounted) {
      getScannersData(currentRequest.token, setScanners, setIsEmpty, setIsLoading);
      interval = setInterval(() => {
        getScannersData(currentRequest.token, setScanners, setIsEmpty, setIsLoading);
      }, 1800000);
    }

    return () => {
      mounted = false;
      clearInterval(interval);
      currentRequest.cancel('Scanners table request canceled by the user.');
    };
  }, []);

  return (
    <S.TableContainer>
      <S.TableHeaderContainer
        {...getToggleProps({ onClick: () => setIsExpanded((opened) => !opened) })}
      >
        <S.IconContainer>{isExpanded ? <ChevronDown /> : <ChevronRight />}</S.IconContainer>
        <S.Title>Scanners</S.Title>
      </S.TableHeaderContainer>
      <div {...getCollapseProps()}>
        <Table
          tableHeaders={scannersHeaders}
          tableData={getObjectToStringMatrix(scanners)}
          loading={isLoading}
          isEmpty={isEmpty}
          renderData={renderData}
        />
      </div>
    </S.TableContainer>
  );
}
